import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'PermissionProfilesCreateForm',

  components: {
    ShButton,
  },

  data() {
    return {
      profile: {
        name: '',
        description: '',
        permissions: 'leads_details_access,record_access,widgets_list_access',
      },
      validationRules: {
        name: { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'userProfiles/create',
        'userProfiles/getList',
      ]);
    },
  },

  methods: {
    handleAddProfile() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          await this.$store.dispatch('userProfiles/create', this.profile);
          await this.$store.dispatch('userProfiles/getList');
          this.$emit('closeModal');
          this.$emit('setProfile');
          this.$notify.success({
            title: 'Nowy profil uprawnień',
            message: 'Dane zapisane poprawnie',
            customClass: 'callmeweb-notification',
          });
          this.$refs.form.resetFields();
        }
      });
    },
  },
};
